import { AppEntity, ContactInformationSchema, PostalAddressSchema } from '@app/icare/db/schema/common'
import { entityId } from '@pkg/db/schema'
import { z } from 'zod'

export const CooperationPartnerId = entityId('cooperationPartner')

export type CooperationPartnerIdType = typeof CooperationPartnerId.Type

export const CooperationPartnerSchema = AppEntity.extend({
  id: CooperationPartnerId.schema,
  name: z.string().min(1).max(255),
  name2: z.string().max(255).nullish(),
  groupName: z.string().max(255).nullish(),
  active: z.coerce.boolean().default(false),
  comment: z.string().nullish(),
  address: PostalAddressSchema.nullish(),
  contact: ContactInformationSchema.nullish(),
})

export type CooperationPartner = z.infer<typeof CooperationPartnerSchema>
